// extracted by mini-css-extract-plugin
export const tigerImage = "today-module--tigerImage--Dnzzz";
export const radarAndPieBox = "today-module--radarAndPieBox--2FLWV";